<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :okButtonProps="{ props: {disabled: disableSubmit && !isSupply} }"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-card  title="矿业权出让公告">
      <a-form :form="form">
        <a-row>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>公告编号：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入公告编号"  :max-length="500" :readOnly="disableSubmit || isSupply" v-decorator="['noticeCode', validatorRules.noticeCode]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>出让公告名称：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入出让公告名称"  :max-length="500" :readOnly="disableSubmit || isSupply" v-decorator="['noticeName', validatorRules.noticeName]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>项目名称：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入项目名称"  :max-length="500" :readOnly="disableSubmit || isSupply" v-decorator="['projectName', validatorRules.projectName]" />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>

          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>项目所在区域：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-area-linkage type="cascader" v-decorator="[ 'projectAreacode', {rules: [{ required: true, message: '请选择注册地', whitespace: true}]} ]"
                style="margin-top: 4px;"  :disabled="disableSubmit || isSupply"/>
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>矿业权类型：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-select v-decorator="['mnsPowType', validatorRules.mnsPowType]" placeholder="请选择" :disabled="disableSubmit || isSupply">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">采矿权</a-select-option>
                  <a-select-option value="2">探矿权</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>出让方式：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <j-dict-select-tag :triggerChange="true" placeholder="请选择出让方式" dictCode="em_transfer_type" v-decorator="['transferType', validatorRules.transferType]"
                                   :disabled="disableSubmit || isSupply"/>
              </a-form-item>
            </a-col>
          </a-col>

        </a-row>
        <a-row>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>矿种：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-select v-decorator="['mineralSpecies', validatorRules.mineralSpecies]" placeholder="请选择" :disabled="disableSubmit || isSupply">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="NY">能源矿产</a-select-option>
                  <a-select-option value="JS">金属矿产</a-select-option>
                  <a-select-option value="FJS">非金矿产</a-select-option>
                  <a-select-option value="SQ">水气矿产</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>出让年限：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input-number placeholder="请输入出让年限"  style="width: 100%" :readOnly="disableSubmit || isSupply"
                                :disabled="disableSubmit || isSupply" v-decorator="['transferYears', validatorRules.transferYears]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>面积：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input-number placeholder="请输入面积"  style="width: 55%" :readOnly="disableSubmit || isSupply"
                                :disabled="disableSubmit || isSupply" v-decorator="['transferArea', validatorRules.transferArea]" />
                平方公里
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>地理位置：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-input placeholder="请输入地理位置"  style="width: 100%" :readOnly="disableSubmit || isSupply" v-decorator="['location', validatorRules.location]" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>公示开始时间：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-range-picker
                  name="publicityGetTime"
                  :disabled="disableSubmit&&!isSupply"
                  v-decorator="['beginRange', { rules: [{ required: true, message: '请选择起止日期' }] }]"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onDateChange"
                  @ok="onDateOk"
                />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="8">
            <a-col :span="9" class="labelTop" >
              <span><font color="red"> *</font>报名截止时间：</span>
            </a-col>
            <a-col :span="15">
              <a-form-item class="itemInput">
                <a-date-picker format="YYYY-MM-DD HH:mm:ss" v-decorator="['registrationDealine', validatorRules.registrationDealine]"  :disabled="disableSubmit&&!isSupply"  />
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row>


        </a-row>
        <a-row>

        </a-row>
        <a-row>
          <a-col :span="3" class="labelTop">
            <span>附件：</span>
          </a-col>
          <a-col :span="20">
            <a-form-item class="itemInput">
              <a-upload
                name="file"
                :action="uploadAction"
                :headers="tokenHeader"
                :file-list="fileList"
                :data="{fp:11}"
                accept=".pdf,.doc,.zip,.rar,.excel,.word"
                :beforeUpload="beforeFileUpload"
                :remove="handleFileRemove"
                @change="handleFileChange"  >
                <a-button v-if="!disableSubmit ||isSupply">
                  <a-icon type="upload"/>
                  上传附件
                </a-button>
              </a-upload>
            </a-form-item>
            <!--style="resize:none;"-->
          </a-col>
        </a-row>
        <a-row v-for="(filesub,index) in modal.fileList" >
          <a-col :span="1" class="labelTop">
            <span></span>
          </a-col>
          <a-col :span="23" class="labelTop" >
            <a-col :span="7" style="text-align: left">
              上传时间：{{filesub.createTime}}
            </a-col>
            <a-col :span="7" :title="filesub.fileName" style="text-align: left;overflow: hidden;">
              文件：  {{filesub.fileName}}
            </a-col>
            <a-col :span="10" class="labelTop" >
              <a :href="filesub.fileUrl" v-show="filesub.id" target="_blank">[下载]</a> &nbsp;&nbsp;&nbsp;&nbsp;
              <a v-if="!disableSubmit"  v-show="filesub.id" @click="deleteFile(filesub.id)">[删除]</a>
            </a-col>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="3" class="labelTop">
            <span>出让公告正文：</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="1" class="labelTop">
          </a-col>
          <a-col :span="22" class="labelTop">
          <JEditor :disabled='disableSubmit&&!isSupply' v-model="jeditor.value" id="editorCentent"></JEditor>
          </a-col>
        </a-row>
      </a-form>
      </a-card>
    </a-spin>
  </a-modal>
</template>

<script>
import {httpAction, postAction} from '@/api/manage'
import pick from 'lodash.pick'
import { getAction } from '@/api/manage'
import JDate from '@/components/fzis/JDate'
import JEditor from '@/components/fzis/JEditor'
import moment from 'moment'
import {getSelectDateRoomScheduleListPage} from '@/api/room'
import Vue from "vue";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  components: { JEditor, JDate},
  name: "MiningRightTransferNoticeModal",
  data () {
    return {
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      title:"操作",
      visible: false,
      disableSubmit:false,
      isSupply:false,
      modal: {},
      confirmLoading: false,
      form: this.$form.createForm(this),
      id:"",
      fileList:[],
      url: {
        addOrUpdate: "/ebid-ce/emTransferNotice/addOrUpdate",
      },
      jeditor: {
        value: ''
      },
    }
  },
  computed: {
    validatorRules: function() {
      return {
        noticeCode: {rules: [{required: true, message: '请输入公告编号'}]},
        noticeName: {rules: [{required: true, message: '请输入出让公告名称'}]},
        projectName: {rules: [{required: true, message: '请输入项目'}]},
        projectAreacode: {rules: [{required: true, message: '请选择项目所在区域'}]},
        mnsPowType: {rules: [{required: true, message: '请选择矿业权'}]},
        mineralSpecies: {rules: [{required: true, message: '请选择矿种类型'}]},
        noticeContent: {rules: [{required: false, message: '请输入公告正文'}]},
        registrationDealine: {rules: [{required: false, message: '请输入截止时间'}]},
        transferType: {rules: [{required: false, message: '请选择出让方式'}]},
        transferYears: {rules: [{required: false, message: '请输入年限'}]},
        transferArea: {rules: [{required: false, message: '请输入出让面积'}]},
        location: {rules: [{required: false, message: '请输入位置'}]},
      }
    },
    uploadAction() {
      return window._CONFIG['domianURL'] + '/ebid-ce/file/onlyUpload'
    },
  },
  created () {
  },
  methods: {
    handleOk(){
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          // if(that.fileList == null || that.fileList.length==0 ){
          //   that.$message.error("请上传附件！");
          //   return;
          // }
          let formData = Object.assign(that.modal, values);
          formData.registrationDealine = moment(formData.registrationDealine).format('YYYY-MM-DD HH:mm:ss');
          formData.noticeContent = this.jeditor.value;
          formData.id=that.id;
          formData.bulletinType="2";//矿业
          formData.beginTime=moment(formData.beginRange[0]).format('YYYY-MM-DD HH:mm:ss');
          formData.endTime=moment(formData.beginRange[0]).format('YYYY-MM-DD HH:mm:ss');
          if(that.linkId)
          {
            formData.linkId=that.linkId;
          }
          if(that.isSupply)
          {
            formData.noticeNature="2";
          }
          console.log("formData",formData)
          console.log("that.modal",that.modal)
          //保存
          postAction(that.url.addOrUpdate,formData).then(res => {
            if (res.success) {
              that.$message.info("保存成功！");
              that.handleCancel();
              that.$emit('loadData');
              return;
            }
            else
            {
              that.$message.error(res.message);
            }
          })
        }
      })

    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.visible = false;
    },
    add() {
      this.visible = true;
      this.model={};
      this.id=null;
      this.form.resetFields();
      this.fileList=[];
      this.jeditor.value="";
      this.modal.fileList=[];
    },
    edit (record){
      this.visible = true;
      this.fileList=[];
      this.form.resetFields();
      this.id=record.id;
      this.getfileList();
      this.jeditor.value=record.noticeContent;
      this.model = Object.assign({}, record);
      this.model.beginRange=[moment(record.beginTime, 'YYYY-MM-DD'),moment(record.endTime, 'YYYY-MM-DD')];

      let that=this;
      let fieldsVal = pick(this.model,'noticeName','noticeCode', 'projectName', 'projectAreacode', 'mnsPowType', 'registrationDealine'
      ,'transferType','mineralSpecies','transferYears','transferArea','location');

      console.log("fieldsVal",fieldsVal)
      this.$nextTick(() => {
        that.form.setFieldsValue(fieldsVal);
        that.form.setFieldsValue({beginRange:this.model.beginRange});
      });

    },
    //补充通告
    editContent(record)
    {
      this.visible = true;
      this.fileList=[];
      this.form.resetFields();
      this.linkId=record.id;
      this.fileList=[];
      this.modal.fileList=[];
      this.jeditor.value=record.noticeContent;
      this.model = Object.assign({}, record);
      this.model.beginRange=[moment(record.beginTime, 'YYYY-MM-DD'),moment(record.endTime, 'YYYY-MM-DD')];
      let that=this;
      let fieldsVal = pick(this.model,'noticeName','noticeCode', 'projectName', 'projectAreacode', 'mnsPowType', 'registrationDealine'
        ,'transferType','mineralSpecies','transferYears','transferArea','location');

      this.$nextTick(() => {
        that.form.setFieldsValue(fieldsVal);
        that.form.setFieldsValue({beginRange:this.model.beginRange});
      });
    },
    beforeFileUpload(file) {
      //限制文件大小
      const isLt = file.size / 1024 / 1024 < 100
      if (!isLt) {
        this.$message.error('上传的文件大小不能超过100M')
        return false
      }
      this.fileList.push(file);
      return true
    },
    handleFileRemove(file)
    {
      if(file.response && this.fileList!=null)
      {
        this.modal.fileList=this.modal.fileList.filter(item => item != file.response.result);
      }
      this.$forceUpdate()
    },
    handleFileChange(info) {
      //console.log("chg",info);
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.fileUploadOk(info.file.response)
        } else {
          for (let i = 0; i < info.fileList.length; i++) {
            if (info.file.uid == info.fileList[i].uid) {
              info.fileList[i].status = 'error'
              break
            }
          }
          this.fileUploadFail(info.file.response)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    fileUploadOk(response) {
      if(this.modal.fileList==null)
      {
        this.modal.fileList=[];
      }
      this.modal.fileList.push(response.result);
      this.$forceUpdate()
    },
    fileUploadFail(response) {
      this.$message.error(response.message)
    },
    onDateChange: function (value, dateString) {
      if(dateString[0] == null || dateString[0] === ""){
        this.modal.beginTime =dateString[0];
        this.modal.endTime=dateString[1];
      }else{
        this.modal.beginTime=moment(dateString[0]).format('YYYY-MM-DD HH:mm:ss');
        this.modal.endTime=moment(dateString[1] + " 23:59:59").format('YYYY-MM-DD HH:mm:ss');
      }
    },
    onDateOk(value) {
      console.log(value);
    },
    //获取附件
    getfileList()
    {
      const that=this;
      this.$nextTick(() => {
        getAction('/ebid-ce/emTransferNotice/file/list', { id: this.id }).then(res => {
          if (res.success) {
            that.modal.fileList=res.result;
            that.$forceUpdate()
          }
        })
      });
    } ,
    deleteFile(fileId) {
      const that = this;
      this.modal.fileList = this.modal.fileList.filter(item => item.id != fileId);
      this.fileList = this.fileList.filter(item => item.id != fileId);
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.labelTop{
  margin-top: 10px;
  text-align: right;
  color:#262626;
}
</style>